import styled from "styled-components";
import logoDesktop from "../../Assets/logo_DESKTOP.svg";
import logoMobile from "../../Assets/logo_MOBILE.svg";
import backgroundDesktop from "../../Assets/headerDesktopBackgroud.svg";
import backgroundMobile from "../../Assets/headerMobileBackground.svg";

export const Container = styled.div`
  height: 100px;
  width: 100%;
  position: absolute;
  background-image: url(${backgroundMobile});
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  background-position-y: -0.1rem;
  @media (min-width: 768px) {
    background-image: url(${backgroundMobile});
    height: 135px;
    width: 500px;
  }
  @media (min-width: 768px) {
    background-image: url(${backgroundDesktop});
  }
`;

export const Logo = styled.div`
  width: 100%;
  height: 100%;
  background-image: url(${logoMobile});
  background-repeat: no-repeat;
  background-position-x: 0.5rem;
  @media (min-width: 768px) {
    background-position-x: 4rem;
    background-image: url(${logoDesktop});
  }
`;
export const PageName = styled.p`
  font-size: 1.5rem;
  width: 200px;
  color: var(--details-color);
  padding-left: 2rem;
  @media (min-width: 768px) {
    padding-left: 3rem;
  }
`;
